import { render } from "./DateRangeDisplayItem.vue?vue&type=template&id=a037ed06&ts=true"
import script from "./DateRangeDisplayItem.vue?vue&type=script&lang=ts"
export * from "./DateRangeDisplayItem.vue?vue&type=script&lang=ts"

import "./DateRangeDisplayItem.vue?vue&type=style&index=0&id=a037ed06&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToggle,QInput,QIcon,QPopupProxy,QDate,QBtn,QTooltip});qInstall(script, 'directives', {ClosePopup});
